import _ from "lodash";
import DetailPageTitleComponent from "../Misc/DetailPageTitle/DetailPageTitleComponent";
import TitleLogoComponent from "../Misc/TitleLogo/TitleLogoComponent";
import TitleTagsComponent from "../Misc/TitleTags/TitleTagsComponent";
import RPRightPanelComponent from "./RPRightPanelComponent/RPRightPanelComponent";
import "./RPDetailBodyComponent/RPDetailBodyComponent.scss";
import DetailPageDescComponent from "../Misc/DetailPageDesc/DetailPageDescComponent";
import VideoPlayer from "react-video-js-player";
import { Spinner } from "react-bootstrap";
import { Rating } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import { submitReviewForm } from "../../../redux/roleplay/actions";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import {
  SessionKeys,
  rolePlayStatus,
  starRatingCaptions,
} from "../../../utils/AppUtils";
import { useNavigate } from "react-router-dom";
import SolutionModal from "../../RolePlay/SolutionModal";
import ConfirmModal from "../../modal/ConfirmModal";

const RPReviewDetailBodyComponent = (props) => {
  let dispatch = useDispatch();
  const {
    id,
    title,
    logoURL,
    logoAltText,
    tagsArray,
    description,
    isLoading,
    setIsLoading,
    setLoaderMsg,
    productData,
    rpData,
    type,
    rubricData,
    role_type,
  } = props;

  let navigate = useNavigate();
  const authBroker = useSelector((state) => state.user.userBroker);
  console.log("rfb-auth", authBroker);
  const reviewResponse = useSelector((state) => state.rolePlay.feedbackForm);
  const [confirmModal, setConfirmModal] = useState(false);
  const [showMsg, setShowMsg] = useState("");

  const [modalShow, setModalShow] = useState(false);
  const [solutionData, setSolutionData] = useState({});
  const [selectedSolution, setSelectedSolution] = useState({});
  const [showGreenTick, setShowGreenTick] = useState(false)

  useEffect(() => {
    console.log("rfb--", reviewResponse);
    if (!_.isEmpty(reviewResponse) && isApiCalled) {
      if (reviewResponse?.status === "success") {
        setConfirmModal(true);
        setShowMsg("Successfully feedback given!");
        setShowGreenTick(true);
        setIsLoading(false);
        setTimeout(() => {
          navigate("/learn/roleplay?tab=3");
        }, 3000);
      }
    }
  }, [reviewResponse]);

  const [formTextArea, setFormTextArea] = useState("");

  const [isApiCalled, setIsApiCalled] = useState(false);

  const [formTextError, setFormTextError] = useState("");

  const sendFeedback = () => {
    if (formTextArea === "") {
      setFormTextError("Please provide comments");
      return;
    }
    setFormTextError("");
    setIsApiCalled(true);
    setIsLoading(true);
    let postData = {
      token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      roleplay_id: productData.roleplay_id,
      roleplay_title: title,
      coach_uid: localStorage.getItem(SessionKeys.USER_ID),
      review_status: "yes",
      rating: rating,
      additional_comment: formTextArea,
      solution_data: selectedSolution,
      // solution_id: Yup.string().optional(),
      // solution_url: Yup.string().optional(),
    };
    console.log(postData);
    dispatch(
      submitReviewForm({
        module: "submitFeedbackRolePlay",
        postData,
      })
    );
    window.scrollTo(0, 0);
  };

  const [rating, setRating] = useState({});
  const handleRatingChange = (item, newValue) => {
    setRating((prevRatings) => ({
      ...prevRatings,
      [item]: newValue, // test rating
    }));
  };

  useEffect(() => {
    console.log("rrr", rating);
  }, [rating]);

  const renderAlertCard = () => {
    return (
      <div
        className={`alert-card d-flex justify-content-center ${
          confirmModal ? "" : "d-none"
        }`}
      >
        <div className="shop-cart">
          <div className="shop-info justify-content-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
            >
              <g
                id="Group_5699"
                data-name="Group 5699"
                transform="translate(0.498 0.498)"
              >
                <circle
                  id="Ellipse_222"
                  data-name="Ellipse 222"
                  cx="9"
                  cy="9"
                  r="9"
                  transform="translate(-0.498 -0.498)"
                  fill="#A9C23C"
                />
                <path
                  id="Icon_material-done"
                  data-name="Icon material-done"
                  d="M9.712,16.558,7.79,14.88l-.9.9L9.712,18.35l6.425-6.657-.9-.9Z"
                  transform="translate(-3.013 -6.071)"
                  fill="#fff"
                  stroke="#fff"
                  strokeWidth="2"
                />
              </g>
            </svg>

            <p className="m-0">{showMsg}</p>
          </div>
          <div className="view-cart-icon">
            <i
              className="fa fa-times cursor-pointer"
              aria-hidden="true"
              onClick={() => {
                setConfirmModal(false);
                setShowMsg("");
              }}
            ></i>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {/* <div className="position-relative p-2 alert-btm">{renderAlertCard()}</div> */}
      <div className="row rp-detail">
        <div className="col-md-8 col-sm-12">
          <div className="left-panel">
            <div className="module-learn-text mt-0">
              {!role_type && (
                <DetailPageTitleComponent title={title} isLoading={isLoading} />
              )}
              {!role_type && (
                <>
                  <div className="d-flex box-meta">
                    <div className="img-box-meta">
                      <TitleLogoComponent
                        logoURL={logoURL}
                        altText={logoAltText}
                        isLoading={isLoading}
                      />
                    </div>
                    <div className="meta-lsit">
                      <TitleTagsComponent
                        tagsArray={tagsArray}
                        isLoading={isLoading}
                      />
                    </div>
                  </div>

                  <DetailPageDescComponent
                    desc={description}
                    isLoading={isLoading}
                  />
                </>
              )}
              <div className="overview-row d-flex mt-3 gap-3 align-items-center">
                <div className="overview-title">Status{"   "} </div>
                <div className="roleplay-status">
                  {rolePlayStatus(
                    productData?.feedback_status
                      ? "feedback_received"
                      : "pending_review",
                    "reviewer"
                  )}
                </div>
              </div>
              <div className="learn-discuss-section">
                {!_.isEmpty(productData) && (
                  <>
                    <div className="video-roleplay">
                      <VideoPlayer
                        id={`assigned-video`}
                        controls={true}
                        src={productData.recorded_url}
                        width="720"
                        height="420"
                        autoPictureInPicture={false}
                        fluid={true}
                        inline={false}
                        pictureInPictureToggle={false}
                        // poster={productData.bannerURL}
                        textTrackSettings={false}
                        type={
                          productData.recorded_url.includes(".mp4")
                            ? "video/mp4"
                            : "application/x-mpegURL"
                        }
                      />
                    </div>
                    {type === "reviewed" ? (
                      ""
                    ) : (
                      <div className="overview-row asgapbtm d-flex align-items-center mt-3 gap-3">
                        <div className="overview-title">Participant Name</div>
                        <div className="usernamewimg">
                          <img
                            className="userimgrolefg"
                            src={
                              productData?.participator_profile_img
                                ? productData?.participator_profile_img
                                : "/images/avatar.svg"
                            }
                          />
                          {productData?.participator_name}
                        </div>
                      </div>
                    )}
                    <div className="overview-card-section mt-3">
                      <div className="overview-row">
                        <h5 className="headfrf">
                          {type === "reviewed"
                            ? "Comments from you"
                            : "Comments from the participant"}
                        </h5>
                        <div className="d-flex ratings-role">
                          {productData?.participator_comment
                            ? productData?.participator_comment
                            : "-"}
                        </div>
                      </div>
                    </div>

                    <div className="sentiment-wrapper mt-5">
                      <div className="sentimant-box">
                        <p className="setimatetitle">Sentiment Analysis</p>
                        <div className="d-flex ratings-role mt-2">
                          <div className="rolerate">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="40"
                              height="40"
                              viewBox="0 0 40 40"
                              fill="none"
                            >
                              <path
                                d="M17.4163 25.8333C18.083 26.5 18.9441 26.8264 19.9997 26.8125C21.0552 26.7986 21.833 26.4167 22.333 25.6667L31.6663 11.6667L17.6663 21C16.9163 21.5 16.5205 22.2639 16.4788 23.2917C16.4372 24.3194 16.7497 25.1667 17.4163 25.8333ZM19.9997 6.66666C21.6386 6.66666 23.215 6.89582 24.7288 7.35416C26.2427 7.81249 27.6663 8.49999 28.9997 9.41666L25.833 11.4167C24.9163 10.9444 23.965 10.5903 22.9788 10.3542C21.9927 10.118 20.9997 9.99999 19.9997 9.99999C16.3052 9.99999 13.1594 11.2986 10.5622 13.8958C7.96495 16.493 6.66634 19.6389 6.66634 23.3333C6.66634 24.5 6.82606 25.6528 7.14551 26.7917C7.46495 27.9305 7.91634 29 8.49968 30H31.4997C32.1386 28.9444 32.6038 27.8472 32.8955 26.7083C33.1872 25.5694 33.333 24.3889 33.333 23.1667C33.333 22.1667 33.215 21.1944 32.9788 20.25C32.7427 19.3055 32.3886 18.3889 31.9163 17.5L33.9163 14.3333C34.7497 15.6389 35.4094 17.0278 35.8955 18.5C36.3816 19.9722 36.6386 21.5 36.6663 23.0833C36.6941 24.6667 36.5136 26.1805 36.1247 27.625C35.7358 29.0694 35.1663 30.4444 34.4163 31.75C34.1108 32.25 33.6941 32.6389 33.1663 32.9167C32.6386 33.1944 32.083 33.3333 31.4997 33.3333H8.49968C7.91634 33.3333 7.36079 33.1944 6.83301 32.9167C6.30523 32.6389 5.88856 32.25 5.58301 31.75C4.86079 30.5 4.30523 29.1736 3.91634 27.7708C3.52745 26.368 3.33301 24.8889 3.33301 23.3333C3.33301 21.0278 3.77051 18.868 4.64551 16.8542C5.52051 14.8403 6.71495 13.0764 8.22884 11.5625C9.74273 10.0486 11.5136 8.85416 13.5413 7.97916C15.5691 7.10416 17.7219 6.66666 19.9997 6.66666Z"
                                fill="black"
                              />
                            </svg>
                            <div className="sentimte-rate-box">
                              <strong>{productData?.recorded_wpm}</strong>
                              <span className="wordtext">Words per minute</span>
                            </div>
                          </div>
                          <div className="rolerate">
                            🙂
                            <div className="sentimte-rate-box">
                              <strong>
                                {productData?.recorded_sentiment_positive}%
                              </strong>
                              <span className="wordtext">Good</span>
                            </div>
                          </div>
                          <div className="rolerate">
                            😐
                            <div className="sentimte-rate-box">
                              <strong>
                                {" "}
                                {productData?.recorded_sentiment_neutral}%
                              </strong>
                              <span className="wordtext">Neutral</span>
                            </div>
                          </div>
                          <div className="rolerate">
                            🙁
                            <div className="sentimte-rate-box">
                              <strong>
                                {" "}
                                {productData?.recorded_sentiment_negative}%
                              </strong>
                              <span className="wordtext">Poor</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {type === "reviewed" && !productData?.feedback_status ? (
                      ""
                    ) : (
                      <div className="row">
                        <div className="review-box-table">
                          {rubricData?.map((item) => {
                            return (
                              <div className="review-rating-sub-box">
                                <div className="rating-title-box">{item}</div>
                                <div className="start-rating-box">
                                  {productData?.feedback_status ? (
                                    <Rating
                                      name={productData}
                                      precision={0.5}
                                      max={3}
                                      readOnly
                                      value={
                                        productData?.feedback_info
                                          ?.rating_provided[item]
                                      }
                                      onChangeActive={(event, newHover) => {}}
                                      emptyIcon={
                                        <StarIcon
                                          style={{ opacity: 0.55 }}
                                          fontSize="inherit"
                                        />
                                      }
                                    />
                                  ) : (
                                    <Rating
                                      name={productData}
                                      precision={0.5}
                                      max={3}
                                      onChange={(event, newValue) => {
                                        // formik.setFieldValue(
                                        //   `rating[${data}]`,
                                        //   newValue
                                        // );
                                        handleRatingChange(item, newValue);
                                      }}
                                      onChangeActive={(event, newHover) => {}}
                                      emptyIcon={
                                        <StarIcon
                                          style={{ opacity: 0.55 }}
                                          fontSize="inherit"
                                        />
                                      }
                                    />
                                  )}
                                </div>
                                {productData?.feedback_status && (
                                  <div className="reviewed-text">
                                    {starRatingCaptions(
                                      _.toNumber(
                                        productData?.feedback_info
                                          ?.rating_provided[item]
                                      )
                                    )}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                    {type === "reviewed" && !productData?.feedback_status ? (
                      ""
                    ) : (
                      <div className="row mt-3">
                        <div className="col-md-12">
                          {productData?.feedback_status ? (
                            <div className="overview-card-section">
                              <div className="overview-row">
                                <h5 className="headfrf">
                                  {type === "reviewed"
                                    ? "Comments from coach"
                                    : "Your Comments"}
                                </h5>
                                <div className="d-flex ratings-role">
                                  {productData?.feedback_info?.reviewer_comment
                                    ? productData?.feedback_info
                                        ?.reviewer_comment
                                    : "-"}
                                </div>
                              </div>
                            </div>
                          ) : (
                            type == "review" && (
                              <>
                                <div className="form-role-sec">
                                  <div className="input-text position-relative">
                                    <label
                                      htmlFor="date_join"
                                      className="input__label"
                                    >
                                      Attach comment to role play
                                    </label>
                                    <textarea
                                      name="Addtional_Comments"
                                      className="input__field commentfield"
                                      rows="4"
                                      cols="50"
                                      placeholder="Enter comment..."
                                      onChange={(e) => {
                                        setFormTextArea(e.target.value);
                                      }}
                                      value={formTextArea}
                                      required
                                    ></textarea>
                                    <span className="roleplay-liner">
                                      The reviewee will see these comments along
                                      with the response itself.
                                    </span>
                                  </div>
                                </div>
                                {formTextError && (
                                  <div style={{ color: "red" }}>
                                    {formTextError}
                                  </div>
                                )}
                              </>
                            )
                          )}
                        </div>
                      </div>
                    )}
                    {type === "review" && !productData?.feedback_status ? (
                      <div className="overview-row mt-3">
                        {!_.isEmpty(productData.solution_data) && (
                          <>
                            <h5 className="headfrf">
                              Suggested Solution
                              {productData?.solution_data?.length > 1
                                ? "s"
                                : ""}
                            </h5>
                            <span className="overview-row">
                              {productData?.solution_data?.map((item) => {
                                return (
                                  <div className="row">
                                    <div className="select-status">
                                      <div className="form-check cursor-pointer">
                                        <input
                                          className="form-check-input cursor-pointer"
                                          type="radio"
                                          name="solutionRadio"
                                          value={item?.add_v_title}
                                          onChange={() =>
                                            setSelectedSolution(item)
                                          }
                                        />
                                        <label
                                          className="form-check-label cursor-pointer"
                                          for="termofusein"
                                          onClick={() => {
                                            setModalShow(true);
                                            setSolutionData({
                                              title: item.add_v_title,
                                              type: item.add_v_type,
                                              url: item.add_v_link,
                                            });
                                          }}
                                        >
                                          {item?.add_v_title} (click to play)
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </span>
                          </>
                        )}
                      </div>
                    ) : type === "reviewed" &&
                      productData?.feedback_status &&
                      !_.isEmpty(
                        productData?.feedback_info?.solution_provided
                      ) ? (
                      <div className="overview-row mt-3">
                        <h5 className="headfrf">Suggested Solution</h5>
                        <span className="overview-row">
                          <div className="row">
                            <div className="select-status">
                              <div className="form-check cursor-pointer">
                                <label
                                  className="form-check-label cursor-pointer"
                                  for="termofusein"
                                  onClick={() => {
                                    setModalShow(true);
                                    setSolutionData({
                                      title:
                                        productData?.feedback_info
                                          ?.solution_provided.add_v_title,
                                      type: productData?.feedback_info
                                        ?.solution_provided.add_v_type,
                                      url: productData?.feedback_info
                                        ?.solution_provided.add_v_link,
                                    });
                                  }}
                                >
                                  {
                                    productData?.feedback_info
                                      ?.solution_provided.add_v_title
                                  }{" "}
                                  (click to play)
                                </label>
                              </div>
                            </div>
                          </div>
                        </span>
                      </div>
                    ) : (
                      ""
                    )}
                    {type === "reviewed" ? (
                      ""
                    ) : type === "review" && !productData.feedback_status ? (
                      <div className="row">
                        <div className="col-md-12">
                          <div className="role_frm_upload_btn edit_btn d-flex">
                            <button
                              className="btn-primary"
                              onClick={() => sendFeedback()}
                            >
                              {false ? (
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                  variant="primary"
                                />
                              ) : (
                                <>Send Feedback</>
                              )}
                            </button>
                          </div>
                          {/* <div className="form-msg">
                        <span>{msg}</span>
                      </div> */}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        {false && (
          <div className="col-md-4 col-sm-12">
            {/* <RPRightPanelComponent video_id={id} /> */}
            {/* <div className="overview-row">
            <h5 className="headfrf">
              Suggested Solution
              {productData?.solution_data?.length > 1 ? "s" : ""}
            </h5>
            <span className="overview-row">
              {productData?.solution_data?.map((item) => {
                return (
                  <div className="row">
                    <div className="select-status">
                      <div className="form-check cursor-pointer">
                        <input
                          className="form-check-input cursor-pointer"
                          type="radio"
                          name="solutionRadio"
                          value={item?.add_v_title}
                        />
                        <label
                          className="form-check-label cursor-pointer"
                          for="termofusein"
                        >
                          {item?.add_v_title}
                        </label>
                      </div>
                    </div>
                  </div>
                );
              })}
            </span>
          </div> */}
          </div>
        )}
      </div>
      <ConfirmModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={showMsg}
        isConfirm={false}
        confirmId={""}
        confirmAction={() => {}}
        isRightIcon={showGreenTick}
      />
      <SolutionModal
        show={modalShow}
        setShow={setModalShow}
        solutionData={solutionData}
        setSolutionData={setSolutionData}
      />
    </>
  );
};

export default RPReviewDetailBodyComponent;
